import { t } from '@/features/i18n/utils';
import { BidBreadcrumbs } from '@/features/bids/components/bid-breadcrumbs';
import { createFileRoute } from '@tanstack/react-router';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderChatButton, HeaderBackButton } from '@/ui/components/header';
import { SummaryPage } from '@/features/summary/components/summary-page';
import z from 'zod';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/summary',
)({
  component: RouteComponent,
  validateSearch: z.object({
    targetStatementId: z.string().optional(),
    commentEntityId: z.string().optional(),
    commentId: z.string().optional(),
  }),
});

function RouteComponent() {
  return (
    <>
      <Header>
        <HeaderBackButton />
        <BidBreadcrumbs>
          <BreadcrumbPage>{t({ en: 'Summary', nb: 'Sammendrag' })}</BreadcrumbPage>
        </BidBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <SummaryPage />
    </>
  );
}
